import trackEvent from '@/client/utils/analytics/trackEvent';
import getCategoryRecommendationUrl from '@/client/utils/getCategoryRecommendation';
import { CategoryRecommendation } from '@/client/types/categoryRecommendation';

type TrackKeywordSearchParams = {
  searchQuery: string;
  recommendedCategory?: CategoryRecommendation | null;
};

const trackKeywordSearch = async ({ searchQuery, recommendedCategory }: TrackKeywordSearchParams): Promise<void> => {
  let recommendedCategoryId = '0';

  try {
    let category = recommendedCategory;

    if (category === undefined || category === null) {
      const result = await getCategoryRecommendationUrl(searchQuery);
      category = result?.category || null;
    }

    if (category?.l2?.categoryId) {
      recommendedCategoryId = String(category.l2.categoryId);
    } else if (category?.l1?.categoryId) {
      recommendedCategoryId = String(category.l1.categoryId);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.debug('Failed to fetch category recommendation for tracking:', error);
  }

  trackEvent({
    eventAction: 'KeywordSearch',
    eventLabel: recommendedCategoryId,
  });
};

export default trackKeywordSearch;
